
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../src/translations/en.json';
import plTranslation from '../src/translations/pl.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    pl: { translation: plTranslation },
  },
  lng: 'pl',
  fallbackLng: 'pl',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
